import { Link } from "react-router-dom";
import { Home, Search, ArrowLeft } from "lucide-react";
import { Logo } from "../components/marketing/MarketingHeader";
import SEO from "../components/SEO";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex flex-col">
      <SEO title="Page introuvable" description="Cette page n'existe pas ou a été déplacée." noIndex />
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/"><Logo /></Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="max-w-2xl w-full bg-white rounded-2xl shadow-lg border border-slate-200 p-8 sm:p-12 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#00B8E4]/10 mb-6">
            <Search className="w-10 h-10 text-[#00B8E4]" />
          </div>
          <p className="text-7xl font-bold text-[#19294C] font-['Outfit'] mb-2">404</p>
          <h1 className="text-2xl sm:text-3xl font-bold text-[#19294C] font-['Outfit'] mb-3">
            Page introuvable
          </h1>
          <p className="text-slate-600 mb-8 max-w-md mx-auto">
            La page que vous cherchez n'existe pas ou a été déplacée. Vérifiez l'URL ou retournez à l'accueil.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#00B8E4] text-white font-semibold hover:bg-[#00A0CC] transition-colors"
            >
              <Home className="w-4 h-4" />
              Retour à l'accueil
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-slate-300 text-[#19294C] font-semibold hover:bg-slate-50 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Page précédente
            </button>
          </div>

          <div className="mt-8 pt-8 border-t border-slate-100 text-sm text-slate-500">
            Besoin d'aide ?{" "}
            <a href="mailto:contact@hostprotect.io" className="text-[#00B8E4] hover:underline">
              contact@hostprotect.io
            </a>
          </div>
        </div>
      </main>

      <footer className="bg-white border-t border-slate-200 py-4 text-center text-xs text-slate-500">
        HostProtect — Assurance location courte durée
      </footer>
    </div>
  );
};

export default NotFoundPage;
